<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div>班级列表</div>
                <div style="cursor: pointer;" @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-addclass">
                    <div @click="handleAdd">新建班级</div>
                </div>
                <div class="mask-content-body-cen">
                    <div class="pc-table pc-table-color">
                        <el-table :data="list" ref="multipleTableW" @selection-change="handleSelectionChange"
                            height="60vh" style="width: 100%" border>
                            <!-- <el-table-column fixed type="selection" align="center" width="62"
                                :selectable="selectableStatus">
                            </el-table-column> -->
                            <el-table-column fixed type="index" align="center" label="序号" width="62">
                            </el-table-column>
                            <el-table-column fixed prop="date" align="center" label="操作" width="62">
                                <template slot-scope="scope">
                                    <div style="color: #C12E30;text-align: center;cursor: pointer;"
                                        @click="handleEdit(scope.row)">编辑</div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="bianhao" label="班级编号" align="center" width="205">
                            </el-table-column>
                            <el-table-column prop="typename" label="班级类型" align="center" width="205"></el-table-column>
                            <el-table-column prop="name" label="班级名称" align="center" width="205">
                            </el-table-column>
                            <el-table-column prop="address" label="班级地点" align="center" width="205"></el-table-column>
                            <el-table-column prop="fee" label="班级费用" width="205" align="center">
                            </el-table-column>
                            <el-table-column prop="name" label="课程状态" width="205" align="center">
                                <template slot-scope="scope">
                                    <div style="color: #C12E30;text-align: center;" v-if="scope.row.coursestatus == 0">
                                        未上传课程</div>
                                    <div style="color: #008858;text-align: center;" v-if="scope.row.coursestatus == 1">
                                        已上传课程</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createtime" label="创建日期" align="center" width="205">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.createtime">
                                        {{ (Number(scope.row.createtime) * 1000) | formatTimestamp("yyyy-MM-dd") }}
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createname" label="创建人" align="center" width="205">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pagination">
                        <div class="pagination-total">共{{ total_count }}条</div>
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="page" :page-sizes="[10, 20, 50, 100, 200, 500, total_count]"
                            :page-size="count" layout="sizes, prev, pager, next, jumper" :total="total_count"
                            background>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <classEdit :dataVal="classObj" @classEditCall="classEditCall"></classEdit>
    </div>
</template>

<script>
export default {
    name: "classList",
    props: ['dataVal'],
    data() {
        return {
            banjitypeArr: [],

            activity_id: '',
            page: 1,
            count: 10,
            total_count: 0,
            //表格列表
            list: [],

            classObj: {
                flag: false
            }
        };
    },
    mounted() {
    },
    methods: {
        async activityBanjilist() {
            let obj = {
                activity_id: this.activity_id,
                page: this.page,
                count: this.count
            }
            let res = await this.$api.activityBanjilist(obj)
            if (res.code == 1) {
                res.data.list.forEach(item => {
                    this.banjitypeArr.forEach(v => {
                        if (item.type_id == v.id) {
                            item.typename = v.values
                        }
                    })
                })
                this.list = res.data.list
                this.total_count = res.data.total_count
            }
        },
        async dictionaryGetbanjitype() {
            let res = await this.$api.dictionaryGetbanjitype()
            if (res.code == 1) {
                this.banjitypeArr = res.data
                this.activityBanjilist()
            }
        },
        handleAdd() {
            localStorage.setItem('activity_id', this.activity_id)
            let url = '/activity/addClass?activity_id=' + this.activity_id
            this.$router.push(url)
        },
        handleEdit(e) {
            this.classObj.id = e.id
            this.classObj.activity_id = e.activity_id
            this.classObj.flag = true
        },
        classEditCall() {
            this.classObj.flag = false
            this.activityBanjilist()
        },
        selectableStatus(row, rowIndex) {
            // 如果行数据中有disabled属性，则返回false禁用多选
            return !row.disabled;
        },
        //表格多选
        handleSelectionChange(val) {
            this.multipleSelection = val.map((row) => row.id);
        },
        //分页事件 点击每页多少条
        handleSizeChange(val) {
            this.page = 1
            //console.log(`每页 ${val} 条`);
            this.count = val;
            this.activityBanjilist()
        },
        //分页事件 点击页数
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            this.activityBanjilist()
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("classListCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
            }
            this.$emit("classListCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.page = 1
                    this.activity_id = newVal.id
                    this.dictionaryGetbanjitype()
                }
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 1306px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
            }
        }

        .mask-content-body {
            width: 100%;
            background-color: #FFF;
            padding: 20px;

            .mask-content-addclass {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;

                div {
                    width: 112px;
                    height: 48px;
                    color: rgba(255, 255, 255, 0.90);
                    font-size: 14px;
                    border-radius: 3px 0 0 0;
                    background: #C12E30;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }

            .mask-content-body-select {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                .mask-content-body-select-title {
                    width: 87px;
                    color: #A6A6A6;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: #C12E30;
                    }
                }

                .mask-content-body-select-input {
                    flex: 1;

                    .el-select {
                        width: 100%;
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 6px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}
</style>